import React, { Fragment, ReactNode } from "react";
import { DrilldownKeys } from "../../../../helpers/reports.helper.types";
import { useIntlTranslate } from "../../../../hooks";
import { widgetTitles } from "../widgetTitles";
import { Mobile, NotMobile } from "../../../../hocs/Responsive";
import { Icon } from "../../../icon/Icon";

import "./WidgetSummary.scss";

export interface SuccessSummaryProps {
  count: number;
  header: ReactNode;
  icon: string;
  id: DrilldownKeys;
}

export const WidgetSuccessSummary = ({
  count,
  header,
  icon,
  id,
}: SuccessSummaryProps) => {
  const translate = useIntlTranslate();
  const iconClass = `fa-regular fa-${icon}`;
  const ariaLabel = translate("aria_widget_count", {
    count,
    type: translate(widgetTitles[id].long),
  });

  return (
    <Fragment>
      <span className="sr-only">{ariaLabel}</span>
      <Mobile>
        <div className={"widget__header"} aria-hidden={true}>
          <div className="widget__title">{header}</div>
          <div className="widget__count">{count}</div>
        </div>
      </Mobile>
      <NotMobile>
        <div className="widget__count" aria-hidden={true}>
          <Icon icon={iconClass} />
          <span>{count}</span>
        </div>
        <div className="widget__title">{header}</div>
      </NotMobile>
    </Fragment>
  );
};
